import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    Grid: {
      flex: 1,
      margin: theme.spacing(6),
      width: "auto",
    },
    identificationFactorButton: { marginRight: theme.spacing(7) },
    input: {
      flex: 1,
      marginTop: theme.spacing(10),
      maxWidth: 373,
      width: "100%",
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(10),
        marginTop: theme.spacing(0),
        maxWidth: "383px !important",
        width: "auto",
      },
    },
    alignCenter: { [theme.breakpoints.up("md")]: { alignSelf: "center" } },
    itemForm: { flex: 1 },
    toggle: { "& label": { margin: 0 } },
  }),
);
